export const isFetchedClients = state => state.clients.isFetched;

export const getClientsList = state => state.clients.data;

export const getMainClient = state => {
  const defaultClientName = config.clientName.toLocaleString();
  const selectedClient = state.clients.data.find(opt => opt.title.toLowerCase() === defaultClientName.toLowerCase());
  
  return selectedClient
};

export const getMainClientId = state => {
  const selectedClient = getMainClient(state);
  
  return selectedClient ? selectedClient.id : null
};
